/// <reference types="google.maps" />
import { Injectable } from "@angular/core";
import constant from '../app.constant';

@Injectable({
    providedIn: 'root'
})
export class GoogleService {
    public readonly apiKey = 'AIzaSyC2mbxrYXdCBhr53MwtdbeV2Sf28BRd2qk'; // Replace with your actual API key

    selectedAddressDetails: any = {}

    public async googleAddressLoad(place: any) {
        this.selectedAddressDetails = {};
        var componentForm = {
            subpremise: {
                long_name: 'sub_premise'
            },
            premise: {
                long_name: 'flat_number'
            },
            street_number: {
                long_name: 'street_number'
            },
            route: {
                long_name: 'street_name'
            },
            neighborhood: {
                long_name: 'neighborhood'
            },
            sublocality_level_2: {
                long_name: 'sublocality_level_2'
            },
            sublocality_level_1: {
                long_name: 'sublocality_level_1'
            },
            locality: {
                long_name: 'locality'
            },
            administrative_area_level_2: {
                long_name: 'district_name',
                short_name: 'district_short_name'
            },
            administrative_area_level_1: {
                long_name: 'state_name',
                short_name: 'state_short_name',
            },
            country: {
                long_name: 'country_name',
                short_name: 'country_short_name',
            },
            postal_code: {
                short_name: 'pincode'
            },
        };
        this.selectedAddressDetails.types = place?.types;
        this.selectedAddressDetails.lat = place?.geometry?.location.lat();
        this.selectedAddressDetails.long = place?.geometry?.location.lng();
        this.selectedAddressDetails.utc_offset = place?.utc_offset_minutes;
        this.selectedAddressDetails.google_place_id = place?.place_id;
        this.selectedAddressDetails.google_map_url = place?.url;
        var appComponent = place?.address_components;
        appComponent?.forEach((element: any) => {
            for (var component in componentForm) {
                if (element.types.includes(component)) {
                    const comp = componentForm[component as keyof typeof componentForm];

                    for (var component2 in comp) {
                        const value = comp[component2 as keyof typeof comp];
                        this.selectedAddressDetails[value] = element[component2];
                    }
                }
            }
        });

        this.selectedAddressDetails.formatted_address = (place.name ? place.name + ' ' : '') + place.formatted_address;
        if (constant.live) {
            this.selectedAddressDetails.district_short_name = this.selectedAddressDetails.district_short_name ? this.selectedAddressDetails.district_short_name : this.selectedAddressDetails.state_short_name;
            this.selectedAddressDetails.district_name = this.selectedAddressDetails.district_name ? this.selectedAddressDetails.district_name : this.selectedAddressDetails.state_name;
        }
        return this.getCityNameFromOtherLocality(this.selectedAddressDetails);

        // })
    }

    getCityNameFromOtherLocality(cityDtl: any) {
        switch (true) {
            case (cityDtl.types.includes('locality')):
                cityDtl.sublocality_type = 'locality';
                cityDtl.city_name = cityDtl.locality;
                break;
            case (cityDtl.types.includes('sublocality_level_1')):
                cityDtl.sublocality_type = 'sublocality_level_1';
                cityDtl.city_name = cityDtl.sublocality_level_1;
                break;
            case (cityDtl.types.includes('sublocality_level_2')):
                cityDtl.sublocality_type = 'sublocality_level_2';
                cityDtl.city_name = cityDtl.sublocality_level_2;
                break;
            case (cityDtl.types.includes('neighborhood')):
                cityDtl.sublocality_type = 'neighborhood';
                cityDtl.city_name = cityDtl.neighborhood;
                break;
            default:
                if (cityDtl.locality) {
                    cityDtl.sublocality_type = 'locality';
                    cityDtl.city_name = cityDtl.locality;
                } else if (cityDtl.sublocality_level_1) {
                    cityDtl.sublocality_type = 'sublocality_level_1';
                    cityDtl.city_name = cityDtl.sublocality_level_1;
                } else if (cityDtl.sublocality_level_2) {
                    cityDtl.sublocality_type = 'sublocality_level_2';
                    cityDtl.city_name = cityDtl.sublocality_level_2;
                } else if (cityDtl.neighborhood) {
                    cityDtl.sublocality_type = 'neighborhood';
                    cityDtl.city_name = cityDtl.neighborhood;
                }
        }
        return cityDtl;
    }




    public googleDistance(value: any, callback: Function) {

        var origin1 = new google.maps.LatLng(value.fromLat, value.fromLong);//pickup
        var destinationA = new google.maps.LatLng(value.toLat, value.toLong);//delivery
        new google.maps.DistanceMatrixService().getDistanceMatrix(
            {
                origins: [origin1],
                destinations: [destinationA],
                travelMode: google.maps.TravelMode.DRIVING,
                unitSystem: google.maps.UnitSystem.METRIC,
                avoidHighways: false,
                avoidTolls: false,
            }, (response) => {
                var responseObj: any = {
                    pickup_address: response?.originAddresses[0],
                    total_distance_in_text: response?.rows[0]?.elements[0]?.distance?.text,
                    total_distance: response?.rows[0]?.elements[0]?.distance?.value,
                    total_time_in_text: response?.rows[0]?.elements[0]?.duration?.text,
                    total_time: response?.rows[0]?.elements[0]?.duration?.value,
                }
                callback(responseObj);

            })
    }

    public calculateAndDisplayRoute(map: any, data: any) {
        var directionsService = new google.maps.DirectionsService();
        var directionsRenderer = new google.maps.DirectionsRenderer();
        directionsRenderer.setMap(map);
        var start = new google.maps.LatLng(data.origin.latitude, data.origin.longitude);
        var end = new google.maps.LatLng(data.destination.latitude, data.destination.longitude);
        directionsService.route({
            origin: start,
            destination: end,
            waypoints: [],
            optimizeWaypoints: true,
            travelMode: google.maps.TravelMode.DRIVING,
        }, (response, status) => {
            if (status === 'OK') {
                directionsRenderer.setDirections(response);
                // If you'll like to display an info window along the route
                // middleStep is used to estimate the midpoint on the route where the info window will appear
                // const middleStep = (response.routes[0].legs[0].steps.length / 2).toFixed();
                // const infowindow2 = new google.maps.InfoWindow();
                // infowindow2.setContent(`${response.routes[0].legs[0].distance.text} <br> ${response.routes[0].legs[0].duration.text}  `);
                // infowindow2.setPosition(response.routes[0].legs[0].steps[middleStep].end_location);
                // infowindow2.open(map);
            } else {
                console.log('Directions request failed due to ' + status);
            }
        });
    }
}

let googleService = new GoogleService();
export default googleService;
